var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('mdb-card',{staticClass:"border border-light"},[_c('mdb-card-body',{staticClass:"p-3"},[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }